export const tokens = {
    value: {
        fontSize: {
            default: 46,
            compact: 28,
        },
    },
};
